// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app'

// Add the Firebase products that you want to use
import 'firebase/remote-config'
import 'firebase/messaging'

import {configuration} from '../../configuration'

export default {

    remoteConfig: {},

    remoteData: {},

    proxy: {},

    messagingToken: '',

    messaging: {},

    init: function () {

        // REMOTE-CONFIG

        this.proxy = new Proxy(this.remoteData, {})

        const firebaseConfig = configuration.firebaseConfig

        firebase.initializeApp(firebaseConfig)

        const remoteConfig = firebase.remoteConfig()

        remoteConfig.settings = {
            minimumFetchIntervalMillis: 3600000,
            fetchTimeoutMillis: 60000
        }

        remoteConfig.fetchAndActivate()
            .then(() => {

                this.proxy.data = remoteConfig.getAll()

            })
            .catch(() => {
            })

        this.remoteConfig = remoteConfig

        // MESSAGING

        if (firebase.messaging && firebase.messaging.isSupported()) {

            this.messaging = firebase.messaging()

            this.messaging.usePublicVapidKey(configuration.firebaseConfig.cloudMessagingCertificat)
        }

        return remoteConfig.fetchAndActivate()

    },


    async getValue(key, type) {

        return await new Promise(resolve => {

            if (this.remoteData.data) {
                resolve(this.extractData(key, type, this.remoteData.data))

            } else {

                setTimeout(() => {
                    resolve(this.getValue(key, type))
                }, 10)

            }
        })

    },

    getAll() {

        return this.remoteConfig.fetchAndActivate()
            .then(() => {

                return this.remoteConfig.getAll()

            })
            .catch(() => {
            })

    },

    extractData(key, type, data) {

        if (data) {
            const object = data[key]

            if (object) {

                switch (type) {
                    case 'Number':
                        return object.asNumber()
                    case 'Boolean':
                        return object.asBoolean()
                    case 'Object':
                        return JSON.parse(object.asString())
                    default:
                        return object.asString()
                }
            }
        }
    }
}
